import BaseVueComponent from "common/BaseVueComponent"
import { Component, Mixins } from "vue-property-decorator"

import { FBannerUtilsMixin } from "./fBanner.utils"

@Component
export default class FBannerBase extends Mixins(BaseVueComponent, FBannerUtilsMixin) {}
